import { render } from "./MyChat.vue?vue&type=template&id=6bc2ad4e&scoped=true"
import script from "./MyChat.vue?vue&type=script&lang=js"
export * from "./MyChat.vue?vue&type=script&lang=js"

import "./MyChat.vue?vue&type=style&index=0&id=6bc2ad4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc2ad4e"]])

export default __exports__